import { useState, useCallback } from "react";
import { useIsomorphicLayoutEffect } from "usehooks-ts";

function getWidth(el, defaultWidth) {
  if (!el) {
    return defaultWidth;
  }
  return el.clientWidth;
}

export default function useComponentWidth(defaultWidth = 0) {
  const [element, ref] = useState(null);
  ref.current = element;
  const [width, setWidth] = useState(getWidth(element, defaultWidth));

  var handleResize = useCallback((element) => {
    if (element) {
      setWidth(getWidth(element, defaultWidth));
    }
  }, []);

  useIsomorphicLayoutEffect(() => {
    if (!element) {
      return;
    }
    handleResize(element);
    if (typeof ResizeObserver === "function") {
      var resizeObserver = new ResizeObserver(() => {
        handleResize(element);
      });
      resizeObserver.observe(element);
      return () => {
        resizeObserver.disconnect(element);
        resizeObserver = null;
      };
    } else {
      window.addEventListener("resize", handleResize);
      return () => {
        window.removeEventListener("resize", handleResize);
      };
    }
  }, [element]);

  return [width, ref];
}
